/* 插入cookie
    name ： 被插入的缓存的key
    val ： 被插入的缓存的value
    time ： 被插入的缓存的过期时间【默认3小时】
*/
export function $setCookie(name, val, time = 120) {
  let t = new Date();
  t.setTime(t.getTime() + time * 60 * 1000);
  document.cookie = name + "=" + val + ";path=/;expires=" + t.toGMTString();
}

// 获取cookie
export function $getCookie(name) {
  let val = document.cookie.match("(^|;s)?" + name + "=([^;]*)(;|$)");
  return val ? val[2] : null;
}

// 删除cookie
export function $delAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=(\=))/g);
  if (keys) {
    for (var i = keys.length; i--;) {
      $setCookie(keys[i], "", -1);
    }
  }
}
// 处理金额格式化【千位逗号分隔】
export function $filterMoney(val) {
  let arr = String(val).split(".");
  if (arr.length === 1) {
    // 不存在小数点
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    if (arr[1].length > 4){
      arr[1] = arr[1].slice(0, 4);
    }
    return `${arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${arr[1]}`;
  }
}

// 根据时间返回问候语
export function $greetFix() {
  const time = new Date();
  const hour = time.getHours();
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好';
}